import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDeviationSelection } from '../../../_hocs/withSelectedDeviations';
import AddDeviationsButton from '../../../_partials/AddDeviationsButton';
import PopupInnerLayout from '../../../_partials/PopupInnerLayout';
import ManageableDeviation from '../../../_partials/ManageableDeviation';
import ManageableSelectedItemsPanel from '../../../_partials/ManageableSelectedItemsPanel';
import { useCurrentTierDeviations } from '../../../_hocs/withCurrentTierDeviations';
import DeviationGrid from '../../DeviationGrid';
import LoadingIndicator from '../../../../LoadingIndicator';
import TierSidebar from './TierSidebar';
import s from './TierDeviationManager.scss';
const TierDeviationManager = (props)=>{
    const { t } = useTranslation();
    const { selectionLimit } = useDeviationSelection();
    const { isInitialized, isFetching, fetchMoreTierDeviations, hasMore, deviations } = useCurrentTierDeviations();
    const renderEmpty = ()=>/*#__PURE__*/ React.createElement("div", {
            className: s['empty-state-container']
        }, t('mediapopup.empty.tier'));
    const deviationRenderer = (deviation, index)=>{
        return /*#__PURE__*/ React.createElement(ManageableDeviation, {
            index: index,
            deviation: deviation
        });
    };
    const renderContent = ()=>{
        return /*#__PURE__*/ React.createElement(React.Fragment, null, isInitialized && (!deviations.length && !hasMore ? renderEmpty() : /*#__PURE__*/ React.createElement(DeviationGrid, {
            deviations: deviations,
            deviationRenderer: deviationRenderer
        })), (!isInitialized || isFetching) && /*#__PURE__*/ React.createElement(LoadingIndicator, {
            coverMode: !isInitialized,
            view: "daSymbol"
        }));
    };
    const fetchMoreTierDeviationsIfNeeded = ()=>{
        if (!hasMore || isFetching) {
            return;
        }
        fetchMoreTierDeviations();
    };
    return /*#__PURE__*/ React.createElement(PopupInnerLayout, {
        headerExtrasRightZone: /*#__PURE__*/ React.createElement(AddDeviationsButton, {
            limit: selectionLimit
        }),
        headerExtrasBottomZone: /*#__PURE__*/ React.createElement(ManageableSelectedItemsPanel, null),
        scrollableContent: renderContent(),
        sideBarContent: /*#__PURE__*/ React.createElement(TierSidebar, null),
        onScrolledToBottom: fetchMoreTierDeviationsIfNeeded,
        onNotScrollable: fetchMoreTierDeviationsIfNeeded
    });
};
TierDeviationManager.displayName = 'TierDeviationManager';
export default TierDeviationManager;
